module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/all-678626d67c7b62132627d1b5ecc772c4.png";